import React from "react";
import Navbar from "../../components/navigation/web/Navbar";
import { ModuleSimulation } from "../../components/Simulation/ModuleSimulation";
import { useTranslation } from "react-i18next";

const Simulation = () => {
	const { t } = useTranslation();
	return (
		<>
			<Navbar
				view={{
					title: t("sim.title"),
					component: (
						<>
							<ModuleSimulation />
						</>
					),
				}}
				right={null}
			/>
		</>
	);
};

export { Simulation };
